<section *ngIf="contentList != null" class="tax-invoice-banner-shared" [ngClass]="customClass">
  <div class="box">
    <ng-container *ngFor="let item of contentList">
      <a [href]="item.link" target="_blank" rel="noopener noreferrer">
        <picture class="box-desktop">
          <source [srcset]="item?.imageWebp" type="image/webp" />
          <img [src]="item.image" class="banner-image" [alt]="item.alt | translate" loading="lazy" />
        </picture>
        <picture class="box-mobile">
          <source [srcset]="item.imageMobileWebp" type="image/webp" />
          <img [src]="item.imageMobile" class="banner-image" [alt]="item.alt | translate" loading="lazy" />
        </picture>
      </a>
      <div class="box-btn" *ngIf="item.hyperLink && item.hyperLinkText">
        <a class="box-btn__link" target="_blank" rel="noreferrer noopener" [href]="item.hyperLink"
          ><span>{{ item.hyperLinkText | translate }}</span></a
        >&nbsp;<i class="fas fa-angle-right"></i
      ></div>
    </ng-container>
  </div>
</section>
